"use client";

import { config } from "@repo/config";
import { cn } from "@ui/lib";

export function Footer({ className }: { className?: string }) {
	return (
		<footer
			className={cn(
				"flex flex-wrap items-center gap-x-4 gap-y-1 text-muted-foreground text-xs",
				className,
			)}
		>
			<span suppressHydrationWarning>
				© {new Date().getFullYear()} {config.appName}
			</span>
		</footer>
	);
}
